import { Component, OnInit, Input } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { SquidexService } from '../../../services/squidex.service'
import { Observable, of, tap } from 'rxjs'
import { SquidexCacheService } from '../../../services/squidex-cache.service'
import { isScullyGenerated, TransferStateService } from '@scullyio/ng-lib'

@Component({
  selector: 'flowaccount-smooth-scroll-anchor-shared',
  templateUrl: './smooth-scroll-anchor-shared.component.html',
  styleUrl: './smooth-scroll-anchor-shared.component.scss',
})
export class SmoothScrollAnchorSharedComponent implements OnInit {
  @Input() styleClass: string
  @Input() contentSquidex: string
  @Input() contentScully: string
  public serviceList$: Observable<object[]>
  constructor(
    public translate: TranslateService,
    public readonly squidexService: SquidexService,
    private squidexCacheService: SquidexCacheService,
    private transferState: TransferStateService,
  ) {}

  ngOnInit(): void {
    if (isScullyGenerated()) {
      this.serviceList$ = this.transferState.useScullyTransferState<object[]>(this.contentScully, of([]))
    } else {
      this.serviceList$ = this.squidexCacheService
        .getServiceList$(
          this.contentScully,
          this.contentSquidex,
          this.squidexService.getContentSquidexApiOrder.bind(this.squidexService),
        )
        .pipe(
          tap((data) => {
            this.transferState.setState(this.contentScully, data)
          }),
        )
    }
  }

  scrollToTarget(targetId: string) {
    const targetElement = document.getElementById(targetId)
    if (targetElement) {
      const offset = targetElement.offsetTop - (window.innerWidth < 1170 ? 100 : 130)
      window.scrollTo({
        top: offset,
        behavior: 'smooth',
      })
    }
  }
}
